{
  "ranges": [
    {
      "id": "south-canal-hall",
      "u": -21,
      "v": -19,
      "angleDeg": 0,
      "length": 38,
      "width": 9,
      "eaves": 9.2,
      "ridge": 14.7,
      "floors": 3,
      "bays": 8,
      "roof": "slate",
      "passage": 0,
      "doorSide": 3
    },
    {
      "id": "south-parallel-range",
      "u": -23,
      "v": -34.5,
      "angleDeg": 0,
      "length": 36,
      "width": 8,
      "eaves": 7.2,
      "ridge": 12.4,
      "floors": 2,
      "bays": 8,
      "roof": "slate",
      "passage": 0,
      "doorSide": 3
    },
    {
      "id": "orchard-annex",
      "u": 42,
      "v": -19,
      "angleDeg": 90,
      "length": 22,
      "width": 7,
      "eaves": 6.6,
      "ridge": 10.4,
      "floors": 2,
      "bays": 5,
      "roof": "slate",
      "passage": 0,
      "doorSide": 0
    }
  ],
  "orchardTrees": [
    [0, 20],
    [12, 20],
    [24, 20],
    [36, 20],
    [48, 20],
    [60, 20],
    [0, 26],
    [14, 26],
    [28, 26],
    [42, 26],
    [56, 26],
    [31, 4],
    [43, 6],
    [55, 4],
    [58, -7],
    [58, -19],
    [58, -31],
    [50, -36],
    [31, -35],
    [20, -35],
    [27, -22],
    [27, -11]
  ],
  "walls": [
    {
      "from": [-13, 14],
      "to": [-13, 28.5],
      "width": 0.35,
      "height": 1.75
    },
    {
      "from": [-13, 28.5],
      "to": [68, 28.5],
      "width": 0.35,
      "height": 1.75
    },
    {
      "from": [68, 28.5],
      "to": [60, -40.5],
      "width": 0.35,
      "height": 1.75
    },
    {
      "from": [60, -40.5],
      "to": [-40, -45],
      "width": 0.35,
      "height": 1.75
    }
  ],
  "note": "Two cross-plot southern bodies and a smaller orchard annex are read as distinct masses in the painting and woodcut. Their precise uses, connections, dimensions, bays and elevations are unresolved; roof colors and hidden elevations are fitted estimates. The 22 representative orchard trees preserve the documented open fruit-tree ground; neither their positions nor their number is a historical count. Boundaries follow local ground and leave a west approach between the unequal ranges. Northern canal houses remain residential; sales and leases from 1532 prevent treating the historical maximum precinct as all private convent use. No later Bushuis, VOC, Walenpleintje houses or southern church vessel is introduced. The source-documented Ursula dividing ditch needs a separate trace."
}
